/**
 * Messages module translations - Pages section
 */

const pages = {
  title: "Messages",
  description: "Here you can see important messages from tax authorities and the Lappa team.",
  addMessage: "Add message",
  addMessageDescription: "Here you can add a message for",
  uploadDocuments: "Upload documents",
  documentRequestForm: {
    storageSpecificsLabel: "Storage specifics",
    storageSpecificsPlaceholder: "Select storage specifics",
    storageSpecificsOptionGeneral: "General",
    storageSpecificsOptionYear: "Year",
    storageSpecificsOptionCountry: "Country",
    storageSpecificsRequired: "Storage specifics is required",
    storageCountryLabel: "Country",
    storageCountryPlaceholder: "Type to search for a country…",
    storageCountryRequired: "Country is required",
    titleLabel: "Request title",
    titlePlaceholder: "Example: Proof of address for account verification",
    applicationsLabel: "Applications",
    projectLtax: "L'tax",
    projectLepr: "L'EPR",
    projectLinvoice: "L'invoice",
    projectLauthorize: "L'Authorize",
    documentCategoryLabel: "Document category",
    productLabel: "Product",
    packageLabel: "Package",
    requiredDocumentsTitle: "Required documents",
    selectAll: "Select all",
    requiredDocumentsHintWithCategory:
      "Select one or more documents the client can upload for this category.",
    requiredDocumentsHintNoCategory:
      "Select a document category first to see available documents.",
    selectedDocumentsTitle: "Selected documents",
    noDocumentsSelectedYet: "No documents selected yet.",
    requirementModeTitle: "Requirement mode",
    requirementModeAllLabel: "All selected documents are required",
    requirementModeAllHelp: "Client must upload every selected document.",
    requirementModeAnyLabel: "Any one of the selected documents is acceptable",
    requirementModeAnyHelp: "Client can choose which document to upload.",
    currentRuleLabel: "Current rule:",
    badgeAllRequired: "All selected documents required",
    badgeAnyOne: "At least one of the selected documents",
    instructionsLabel: "Instructions / Additional description",
    instructionsPlaceholder:
      "Explain why you need these documents and how to prepare them.",
    attachTemplateLabel: "Attach template",
    attachTemplateHelper:
      "Optional: upload sample documents to guide the client.",
    deadlineLabel: "Deadline",
    allowedFormatsTitle: "Allowed formats",
    allowedFormatsHint:
      "The client will see these formats as recommendations in the upload section.",
    formatPdf: "PDF",
    formatJpg: "JPG",
    formatPng: "PNG",
    formatJpeg: "JPEG",
    formatTiff: "TIFF",
    internalNoteLabel: "Attach internal note (hidden from client)",
    internalNotePlaceholder: "Visible only to your team.",
    submitButton: "Submit",
    validationTitleRequired: "Title is required",
    validationCategoryRequired: "Category is required",
    validationDocumentsMin: "Select at least one document",
    validationSkuGpsrRequired: "Product is required for GPSR category",
    validationPackagePpwrRequired: "Package is required for PPWR category",
    formSuccessCreated: "Request created successfully",
    formErrorCreateFailed: "Failed to create document request",
  },
};

export default pages;
